module.exports = __webpack_public_path__ + "img/RD.7b924318.png";